export const DISABLED = 0;
export const ENABLED = 3;
export const PROGRAMMABLE = 16;
